import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import DecodeText from "./DecodeText";
import HudLabel from "./HudLabel";
import DotsText from "./DotsText";
import CategoryRail from "./CategoryRail";
import EntryList from "./EntryList";
import EntryDetail from "./EntryDetail";
import { filterEntries } from "../lib/filterEntries";
import "./Timeline.css";

/** The "mission log": category rail + entry list + detail panel. */
export default function Timeline({ timeline, categories }) {
  // Default to Work Experience, opened on Deloitte.
  const [category, setCategory] = useState("experience");
  const [selectedId, setSelectedId] = useState("deloitte-qa");

  const entries = useMemo(() => filterEntries(timeline, category), [timeline, category]);

  const chooseCategory = (id) => {
    setCategory(id);
    const first = filterEntries(timeline, id)[0];
    if (first) setSelectedId(first.id);
  };

  const selected = entries.find((e) => e.id === selectedId) || entries[0];

  return (
    <section id="timeline" className="section timeline">
      <motion.header
        className="timeline__head"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
      >
        <HudLabel className="timeline__eyebrow" text="MISSION LOG" />
        <DecodeText as="h2" className="timeline__title hud-title" text="Timeline" />
        <DotsText
          as="p"
          className="timeline__count"
          text={`${entries.length} ${entries.length === 1 ? "entry" : "entries"}`}
        />
      </motion.header>

      <div className="timeline__grid">
        <CategoryRail categories={categories} active={category} onSelect={chooseCategory} />
        <EntryList
          entries={entries}
          selectedId={selected?.id}
          onSelect={setSelectedId}
          category={category}
        />
        <EntryDetail entry={selected} />
      </div>
    </section>
  );
}
